module.exports = __webpack_public_path__ + "static/media/banner@3x.585258b8.png";